import { useEffect, useState } from 'react';
import axios from '../../../../../axios';
import API from 'actions/api';

const DASHBOARD_BASE = `${API}/dashboard`;

const normalizeResults = (response = {}) => {
  if (!response || typeof response !== 'object') {
    return [];
  }
  if (Array.isArray(response)) {
    return response;
  }
  if (Array.isArray(response.results)) {
    return response.results;
  }
  return [];
};

export const useAssetMasterData = () => {
  const [state, setState] = useState({
    objects: [],
    securities: [],
    realEstates: [],
    loading: true,
  });

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        const [objectsRes, securitiesRes, realEstateRes] = await Promise.all([
          axios.get(`${DASHBOARD_BASE}/valubale_object`),
          axios.get(`${DASHBOARD_BASE}/securities`),
          axios.get(`${DASHBOARD_BASE}/real_estate`),
        ]);

        if (!isMounted) {
          return;
        }

        setState({
          objects: normalizeResults(objectsRes.data),
          securities: normalizeResults(securitiesRes.data),
          realEstates: normalizeResults(realEstateRes.data),
          loading: false,
        });
      } catch (error) {
        if (!isMounted) {
          return;
        }
        setState((prev) => ({
          ...prev,
          loading: false,
        }));
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, []);

  return state;
};
